import Vue from 'vue'
import VueRouter from 'vue-router'
import ElementUI from "element-ui";
import store from '../store'

Vue.use(VueRouter)
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}
const router = new VueRouter({
    base: '/ediconac/',
    mode: 'history',
    routes: [{
            path: '/',
            name: 'home',
            // redirect:'/register-ol',
            component: resolve => (require(["@/pages/home/index.vue"], resolve)),
            meta: {
                title: 'EDICON CHINA 2024', //导航名称
                menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: 'EDICON CHINA 2024',
                    meta: [{
                        name: 'keywords',
                        content: 'EDICON CHINA 2024'
                    }, {
                        name: "description",
                        content: 'EDICON CHINA 2024'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/abstracts-ol',
            name: 'abstracts-ol',
            component: resolve => (require(["@/pages/home/abstracts-ol.vue"], resolve)),
            meta: {
                title: '报名', //导航名称
                menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '报名',
                    meta: [{
                        name: 'keywords',
                        content: '报名'
                    }, {
                        name: "description",
                        content: '报名'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/abstracts-22bj',
            name: 'abstracts-22bj',
            component: resolve => (require(["@/pages/home/abstracts-22bj.vue"], resolve)),
            meta: {
                title: '报名', //导航名称
                menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '报名',
                    meta: [{
                        name: 'keywords',
                        content: '报名'
                    }, {
                        name: "description",
                        content: '报名'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/abstracts-22sh',
            name: 'abstracts-22sh',
            component: resolve => (require(["@/pages/home/abstracts-22sh.vue"], resolve)),
            meta: {
                title: '报名', //导航名称
                menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '报名',
                    meta: [{
                        name: 'keywords',
                        content: '报名'
                    }, {
                        name: "description",
                        content: '报名'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/abstracts-22cd',
            name: 'abstracts-22cd',
            component: resolve => (require(["@/pages/home/abstracts-22cd.vue"], resolve)),
            meta: {
                title: '报名', //导航名称
                menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '报名',
                    meta: [{
                        name: 'keywords',
                        content: '报名'
                    }, {
                        name: "description",
                        content: '报名'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/speakers-ol',
            name: 'speakers-ol',
            component: resolve => (require(["@/pages/home/speakers-ol.vue"], resolve)),
            meta: {
                title: '报名', //导航名称
                menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '报名',
                    meta: [{
                        name: 'keywords',
                        content: '报名'
                    }, {
                        name: "description",
                        content: '报名'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/speakers-22cd',
            name: 'speakers-22cd',
            component: resolve => (require(["@/pages/home/speakers-22cd.vue"], resolve)),
            meta: {
                title: '报名', //导航名称
                menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '报名',
                    meta: [{
                        name: 'keywords',
                        content: '报名'
                    }, {
                        name: "description",
                        content: '报名'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/speakers-22bj',
            name: 'speakers-22bj',
            component: resolve => (require(["@/pages/home/speakers-22bj.vue"], resolve)),
            meta: {
                title: '报名', //导航名称
                menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '报名',
                    meta: [{
                        name: 'keywords',
                        content: '报名'
                    }, {
                        name: "description",
                        content: '报名'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/speakers-22sh',
            name: 'speakers-22sh',
            component: resolve => (require(["@/pages/home/speakers-22sh.vue"], resolve)),
            meta: {
                title: '报名', //导航名称
                menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '报名',
                    meta: [{
                        name: 'keywords',
                        content: '报名'
                    }, {
                        name: "description",
                        content: '报名'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/sponsors-ol',
            name: 'sponsors-ol',
            component: resolve => (require(["@/pages/home/sponsors-ol.vue"], resolve)),
            meta: {
                title: '报名', //导航名称
                menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '报名',
                    meta: [{
                        name: 'keywords',
                        content: '报名'
                    }, {
                        name: "description",
                        content: '报名'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/sponsors-22cd',
            name: 'sponsors-22cd',
            component: resolve => (require(["@/pages/home/sponsors-22cd.vue"], resolve)),
            meta: {
                title: '报名', //导航名称
                menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '报名',
                    meta: [{
                        name: 'keywords',
                        content: '报名'
                    }, {
                        name: "description",
                        content: '报名'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/sponsors-22sz',
            name: 'sponsors-22sz',
            component: resolve => (require(["@/pages/home/sponsors-22sz.vue"], resolve)),
            meta: {
                title: '报名', //导航名称
                menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '报名',
                    meta: [{
                        name: 'keywords',
                        content: '报名'
                    }, {
                        name: "description",
                        content: '报名'
                    }]
                },
                requireAuth: false
            }
        },

        {
            path: '/sponsors-22bj',
            name: 'sponsors-22bj',
            component: resolve => (require(["@/pages/home/sponsors-22bj.vue"], resolve)),
            meta: {
                title: '报名', //导航名称
                menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '报名',
                    meta: [{
                        name: 'keywords',
                        content: '报名'
                    }, {
                        name: "description",
                        content: '报名'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/sponsors-23sh',
            name: 'sponsors-23sh',
            component: resolve => (require(["@/pages/home/sponsors-23sh.vue"], resolve)),
            meta: {
                title: '报名', //导航名称
                menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '报名',
                    meta: [{
                        name: 'keywords',
                        content: '报名'
                    }, {
                        name: "description",
                        content: '报名'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/sponsors-23cd',
            name: 'sponsors-23cd',
            component: resolve => (require(["@/pages/home/sponsors-23cd.vue"], resolve)),
            meta: {
                title: '报名', //导航名称
                menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '报名',
                    meta: [{
                        name: 'keywords',
                        content: '报名'
                    }, {
                        name: "description",
                        content: '报名'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/sponsors-24cd',
            name: 'sponsors-24cd',
            component: resolve => (require(["@/pages/home/24cd/sponsors-24cd.vue"], resolve)),
            meta: {
                title: '报名', //导航名称
                menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '报名',
                    meta: [{
                        name: 'keywords',
                        content: '报名'
                    }, {
                        name: "description",
                        content: '报名'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/sponsors-22sh',
            name: 'sponsors-22sh',
            component: resolve => (require(["@/pages/home/sponsors-22sh.vue"], resolve)),
            meta: {
                title: '报名', //导航名称
                menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '报名',
                    meta: [{
                        name: 'keywords',
                        content: '报名'
                    }, {
                        name: "description",
                        content: '报名'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/exhibits-22cd',
            name: 'exhibits-22cd',
            component: resolve => (require(["@/pages/home/exhibits-22cd.vue"], resolve)),
            meta: {
                title: '报名', //导航名称
                menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '报名',
                    meta: [{
                        name: 'keywords',
                        content: '报名'
                    }, {
                        name: "description",
                        content: '报名'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/exhibits-22bj',
            name: 'exhibits-22bj',
            component: resolve => (require(["@/pages/home/exhibits-22bj.vue"], resolve)),
            meta: {
                title: '报名', //导航名称
                menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '报名',
                    meta: [{
                        name: 'keywords',
                        content: '报名'
                    }, {
                        name: "description",
                        content: '报名'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/exhibits-22sh',
            name: 'exhibits-22sh',
            component: resolve => (require(["@/pages/home/exhibits-22sh.vue"], resolve)),
            meta: {
                title: '报名', //导航名称
                menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '报名',
                    meta: [{
                        name: 'keywords',
                        content: '报名'
                    }, {
                        name: "description",
                        content: '报名'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/test',
            name: 'test',
            component: resolve => (require(["@/pages/home/test.vue"], resolve)),
            meta: {
                title: '报名', //导航名称
                menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '报名',
                    meta: [{
                        name: 'keywords',
                        content: '报名'
                    }, {
                        name: "description",
                        content: '报名'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/register-ol',
            name: 'register-ol',
            component: resolve => (require(["@/pages/user/register-ol.vue"], resolve)),
            meta: {
                title: '报名', //导航名称
                // menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '报名',
                    meta: [{
                        name: 'keywords',
                        content: '报名'
                    }, {
                        name: "description",
                        content: '报名'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/register-22bj',
            name: 'register-22bj',
            component: resolve => (require(["@/pages/user/register-22bj.vue"], resolve)),
            meta: {
                title: '报名', //导航名称
                // menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '报名',
                    meta: [{
                        name: 'keywords',
                        content: '报名'
                    }, {
                        name: "description",
                        content: '报名'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/register-22cd',
            name: 'register-22cd',
            component: resolve => (require(["@/pages/user/register-22cd.vue"], resolve)),
            meta: {
                title: '报名', //导航名称
                // menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '报名',
                    meta: [{
                        name: 'keywords',
                        content: '报名'
                    }, {
                        name: "description",
                        content: '报名'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/register-22sz',
            name: 'register-22sz',
            component: resolve => (require(["@/pages/user/register-22sz.vue"], resolve)),
            meta: {
                title: '报名', //导航名称
                // menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '报名',
                    meta: [{
                        name: 'keywords',
                        content: '报名'
                    }, {
                        name: "description",
                        content: '报名'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/content-23ol',
            name: 'content-23ol',
            component: resolve => (require(["@/pages/home/content-23ol.vue"], resolve)),
            meta: {
                title: '报名', //导航名称
                // menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '报名',
                    meta: [{
                        name: 'keywords',
                        content: '报名'
                    }, {
                        name: "description",
                        content: '报名'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/content-24cd',
            name: 'content-24cd',
            component: resolve => (require(["@/pages/home/24cd/content-24cd.vue"], resolve)),
            meta: {
                title: '报名', //导航名称
                // menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '报名',
                    meta: [{
                        name: 'keywords',
                        content: '报名'
                    }, {
                        name: "description",
                        content: '报名'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/content-23sh',
            name: 'content-23sh',
            component: resolve => (require(["@/pages/home/content-23sh.vue"], resolve)),
            meta: {
                title: '报名', //导航名称
                // menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '报名',
                    meta: [{
                        name: 'keywords',
                        content: '报名'
                    }, {
                        name: "description",
                        content: '报名'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/content-23cd',
            name: 'content-23cd',
            component: resolve => (require(["@/pages/home/content-23cd.vue"], resolve)),
            meta: {
                title: '报名', //导航名称
                // menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '报名',
                    meta: [{
                        name: 'keywords',
                        content: '报名'
                    }, {
                        name: "description",
                        content: '报名'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/register-23ol',
            name: 'register-23ol',
            component: resolve => (require(["@/pages/user/register-23ol.vue"], resolve)),
            meta: {
                title: '报名', //导航名称
                // menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '报名',
                    meta: [{
                        name: 'keywords',
                        content: '报名'
                    }, {
                        name: "description",
                        content: '报名'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/register-23sh',
            name: 'register-23sh',
            component: resolve => (require(["@/pages/user/register-23sh.vue"], resolve)),
            meta: {
                title: '报名', //导航名称
                // menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '报名',
                    meta: [{
                        name: 'keywords',
                        content: '报名'
                    }, {
                        name: "description",
                        content: '报名'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/register-23cd',
            name: 'register-23cd',
            component: resolve => (require(["@/pages/user/register-23cd.vue"], resolve)),
            meta: {
                title: '报名', //导航名称
                // menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '报名',
                    meta: [{
                        name: 'keywords',
                        content: '报名'
                    }, {
                        name: "description",
                        content: '报名'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/register-24cd',
            name: 'register-24cd',
            component: resolve => (require(["@/pages/home/24cd/register-24cd.vue"], resolve)),
            meta: {
                title: '报名', //导航名称
                // menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '报名',
                    meta: [{
                        name: 'keywords',
                        content: '报名'
                    }, {
                        name: "description",
                        content: '报名'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/content-22sz',
            name: 'content-22sz',
            component: resolve => (require(["@/pages/home/content-22sz.vue"], resolve)),
            meta: {
                title: '报名', //导航名称
                // menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '报名',
                    meta: [{
                        name: 'keywords',
                        content: '报名'
                    }, {
                        name: "description",
                        content: '报名'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/register-22sh',
            name: 'register-22sh',
            component: resolve => (require(["@/pages/user/register-22sh.vue"], resolve)),
            meta: {
                title: '报名', //导航名称
                // menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '报名',
                    meta: [{
                        name: 'keywords',
                        content: '报名'
                    }, {
                        name: "description",
                        content: '报名'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/login',
            name: 'login',
            component: resolve => (require(["@/pages/user/login.vue"], resolve)),
            meta: {
                title: '登录', //导航名称
                // menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '登录',
                    meta: [{
                        name: 'keywords',
                        content: '登录'
                    }, {
                        name: "description",
                        content: '登录'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/share',
            name: 'share',
            component: resolve => (require(["@/pages/home/share.vue"], resolve)),
            meta: {
                title: '登录', //导航名称
                // menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '登录',
                    meta: [{
                        name: 'keywords',
                        content: '登录'
                    }, {
                        name: "description",
                        content: '登录'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/gift',
            name: 'gift',
            component: resolve => (require(["@/pages/home/gift.vue"], resolve)),
            meta: {
                title: '登录', //导航名称
                // menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '登录',
                    meta: [{
                        name: 'keywords',
                        content: '登录'
                    }, {
                        name: "description",
                        content: '登录'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/organizers',
            name: 'organizers',
            component: resolve => (require(["@/pages/home/organizers.vue"], resolve)),
            meta: {
                title: '主办单位', //导航名称
                // menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '主办单位',
                    meta: [{
                        name: 'keywords',
                        content: '主办单位'
                    }, {
                        name: "description",
                        content: '主办单位'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/edi-con-across-china',
            name: 'edi-con-across-china',
            component: resolve => (require(["@/pages/home/edi-con-across-china.vue"], resolve)),
            meta: {
                title: '主办单位', //导航名称
                // menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '主办单位',
                    meta: [{
                        name: 'keywords',
                        content: '主办单位'
                    }, {
                        name: "description",
                        content: '主办单位'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/contact-us',
            name: 'contact-us',
            component: resolve => (require(["@/pages/home/contact-us.vue"], resolve)),
            meta: {
                title: '主办单位', //导航名称
                // menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '主办单位',
                    meta: [{
                        name: 'keywords',
                        content: '主办单位'
                    }, {
                        name: "description",
                        content: '主办单位'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/schedule-ol',
            name: 'schedule-ol',
            component: resolve => (require(["@/pages/home/schedule-ol.vue"], resolve)),
            meta: {
                title: '议程表', //导航名称
                // menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '议程表',
                    meta: [{
                        name: 'keywords',
                        content: '议程表'
                    }, {
                        name: "description",
                        content: '议程表'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/schedule-22bj',
            name: 'schedule-22bj',
            component: resolve => (require(["@/pages/home/schedule-22bj.vue"], resolve)),
            meta: {
                title: '议程表', //导航名称
                // menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '议程表',
                    meta: [{
                        name: 'keywords',
                        content: '议程表'
                    }, {
                        name: "description",
                        content: '议程表'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/schedule-22cd',
            name: 'schedule-22cd',
            component: resolve => (require(["@/pages/home/schedule-22cd.vue"], resolve)),
            meta: {
                title: '议程表', //导航名称
                // menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '议程表',
                    meta: [{
                        name: 'keywords',
                        content: '议程表'
                    }, {
                        name: "description",
                        content: '议程表'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/schedule-22sz',
            name: 'schedule-22sz',
            component: resolve => (require(["@/pages/home/schedule-22sz.vue"], resolve)),
            meta: {
                title: '议程表', //导航名称
                // menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '议程表',
                    meta: [{
                        name: 'keywords',
                        content: '议程表'
                    }, {
                        name: "description",
                        content: '议程表'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/schedule-23ol',
            name: 'schedule-23ol',
            component: resolve => (require(["@/pages/home/schedule-23ol.vue"], resolve)),
            meta: {
                title: '议程表', //导航名称
                // menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '议程表',
                    meta: [{
                        name: 'keywords',
                        content: '议程表'
                    }, {
                        name: "description",
                        content: '议程表'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/schedule-22sh',
            name: 'schedule-22sh',
            component: resolve => (require(["@/pages/home/schedule-22sh.vue"], resolve)),
            meta: {
                title: '议程表', //导航名称
                // menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '议程表',
                    meta: [{
                        name: 'keywords',
                        content: '议程表'
                    }, {
                        name: "description",
                        content: '议程表'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/schedule-23sh',
            name: 'schedule-23sh',
            component: resolve => (require(["@/pages/home/schedule-23sh.vue"], resolve)),
            meta: {
                title: '议程表', //导航名称
                // menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '议程表',
                    meta: [{
                        name: 'keywords',
                        content: '议程表'
                    }, {
                        name: "description",
                        content: '议程表'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/schedule-23cd',
            name: 'schedule-23cd',
            component: resolve => (require(["@/pages/home/schedule-23cd.vue"], resolve)),
            meta: {
                title: '议程表', //导航名称
                // menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '议程表',
                    meta: [{
                        name: 'keywords',
                        content: '议程表'
                    }, {
                        name: "description",
                        content: '议程表'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/schedule-24cd',
            name: 'schedule-24cd',
            component: resolve => (require(["@/pages/home/24cd/schedule-24cd.vue"], resolve)),
            meta: {
                title: '议程表', //导航名称
                // menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '议程表',
                    meta: [{
                        name: 'keywords',
                        content: '议程表'
                    }, {
                        name: "description",
                        content: '议程表'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/venue',
            name: 'venue',
            component: resolve => (require(["@/pages/home/venue.vue"], resolve)),
            meta: {
                title: '会址', //导航名称
                // menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '会址',
                    meta: [{
                        name: 'keywords',
                        content: '会址'
                    }, {
                        name: "description",
                        content: '会址'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/venue-22sh',
            name: 'venue-22sh',
            component: resolve => (require(["@/pages/home/venue-22sh.vue"], resolve)),
            meta: {
                title: '会址', //导航名称
                // menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '会址',
                    meta: [{
                        name: 'keywords',
                        content: '会址'
                    }, {
                        name: "description",
                        content: '会址'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/venue-23sh',
            name: 'venue-23sh',
            component: resolve => (require(["@/pages/home/venue-23sh.vue"], resolve)),
            meta: {
                title: '会址', //导航名称
                // menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '会址',
                    meta: [{
                        name: 'keywords',
                        content: '会址'
                    }, {
                        name: "description",
                        content: '会址'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/venue-23cd',
            name: 'venue-23cd',
            component: resolve => (require(["@/pages/home/venue-23cd.vue"], resolve)),
            meta: {
                title: '会址', //导航名称
                // menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '会址',
                    meta: [{
                        name: 'keywords',
                        content: '会址'
                    }, {
                        name: "description",
                        content: '会址'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/venue-24cd',
            name: 'venue-24cd',
            component: resolve => (require(["@/pages/home/24cd/venue-24cd.vue"], resolve)),
            meta: {
                title: '会址', //导航名称
                // menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '会址',
                    meta: [{
                        name: 'keywords',
                        content: '会址'
                    }, {
                        name: "description",
                        content: '会址'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/venue-22cd',
            name: 'venue-22cd',
            component: resolve => (require(["@/pages/home/venue-22cd.vue"], resolve)),
            meta: {
                title: '会址', //导航名称
                // menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '会址',
                    meta: [{
                        name: 'keywords',
                        content: '会址'
                    }, {
                        name: "description",
                        content: '会址'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/venue-22sz',
            name: 'venue-22sz',
            component: resolve => (require(["@/pages/home/venue-22sz.vue"], resolve)),
            meta: {
                title: '会址', //导航名称
                // menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '会址',
                    meta: [{
                        name: 'keywords',
                        content: '会址'
                    }, {
                        name: "description",
                        content: '会址'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/ppt-download-23ol',
            name: 'ppt-download-23ol',
            component: resolve => (require(["@/pages/home/download.vue"], resolve)),
            meta: {
                title: '会址', //导航名称
                // menuShow: true,
                //定义metaInfo
                metaInfo: {
                    title: '会址',
                    meta: [{
                        name: 'keywords',
                        content: '会址'
                    }, {
                        name: "description",
                        content: '会址'
                    }]
                },
                requireAuth: false
            }
        },
        {
            path: '/personal',
            name: 'index',
            redirect: '/personal/info',
            component: resolve => (require(["@/pages/user/index.vue"], resolve)),
            meta: {

                title: '个人中心',
                menuShow: true,
                metaInfo: {
                    title: '个人信息',
                    meta: [{
                        name: 'keywords',
                        content: 'act'
                    }, {
                        name: "description",
                        content: '个人信息'
                    }]
                },
                requireAuth: true
            },
            children: [{
                    path: '/personal/info',
                    name: 'info',
                    component: resolve => (require(["@/pages/user/info.vue"], resolve)),
                    meta: {

                        title: '个人中心',
                        menuShow: true,
                        metaInfo: {
                            title: '个人资料',
                            meta: [{
                                name: 'keywords',
                                content: 'act'
                            }, {
                                name: "description",
                                content: '个人资料'
                            }]
                        },
                        requireAuth: true
                    }
                },
                {
                    path: '/personal/speech',
                    name: 'speech',
                    component: resolve => (require(["@/pages/user/speech.vue"], resolve)),
                    meta: {

                        title: '个人中心',
                        menuShow: true,
                        metaInfo: {
                            title: '个人资料',
                            meta: [{
                                name: 'keywords',
                                content: 'act'
                            }, {
                                name: "description",
                                content: '个人资料'
                            }]
                        },
                        requireAuth: true
                    }
                },
                {
                    path: '/personal/teacher',
                    name: 'teacher',
                    component: resolve => (require(["@/pages/user/teacher.vue"], resolve)),
                    meta: {

                        title: '个人中心',
                        menuShow: true,
                        metaInfo: {
                            title: '个人资料',
                            meta: [{
                                name: 'keywords',
                                content: 'act'
                            }, {
                                name: "description",
                                content: '个人资料'
                            }]
                        },
                        requireAuth: true
                    }
                },
                {
                    path: '/personal/exhibits',
                    name: 'exhibits',
                    component: resolve => (require(["@/pages/user/exhibits.vue"], resolve)),
                    meta: {

                        title: '个人中心',
                        menuShow: true,
                        metaInfo: {
                            title: '个人资料',
                            meta: [{
                                name: 'keywords',
                                content: 'act'
                            }, {
                                name: "description",
                                content: '个人资料'
                            }]
                        },
                        requireAuth: true
                    }
                },

            ]
        },

    ],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    },
})
export default router
router.beforeEach((to, from, next) => {
    if (!store.getters.lang) {
        let lang = navigator.language.toLowerCase()
        if (lang === 'zh' || lang === 'zh-cn') {
            store.commit('setLang', 'zh-CN')
        } else {
            store.commit('setLang', 'en-US')
        }
    }
    if (to.matched.length === 0) { // 如果未匹配到路由
        from.name ? next({ name: from.name }) : next('/')
    } else {
        //store.commit('showLoading',true);
        next() // 如果匹配到正确跳转
    }
    if (to.matched.some(record => record.meta.requireAuth)) {
        next()
        var token = store.getters.access_token

        console.log(token)
        if (!token || token == '') {
            ElementUI.Message({
                message: '请先登录',
                type: 'error',
            });
            next({
                path: '/login',
                query: { redirect: to.fullPath } // 将跳转的路由path作为参数，登录成功后跳转到该路由
            });
        } else {
            store.commit('showLoading', true);
            next()
        }
    } else {
        next()
    }
})
router.onError((error) => {
    const pattern = /Loading chunk (\d)+ failed/g;
    const isChunkLoadFailed = error.message.match(pattern);
    const targetPath = router.history.pending.fullPath;
    if (isChunkLoadFailed) {
        router.replace(targetPath);
    }
});


// WEBPACK FOOTER //
// ./src/router/index.js